import React from "react";

const StrongFoundations = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#eef3ff] via-[#f7f5ff] to-white">
      {/* Glow orbs */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#064585]/25 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -right-32 h-96 w-96 rounded-full bg-[#5989C8]/25 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-16">
        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14">
          {/* Lef animation */}
          <div
            className="w-full md:w-1/2 flex justify-center"
            data-aos="fade-right"
          >
            <div className="relative w-full max-w-md h-72 md:h-80">
              <div className="absolute inset-0 rounded-3xl bg-gradient-to-br from-[#64a2ff]/30 via-[#5989C8]/20 to-[#064585]/40 blur-2xl" />

              <div className="absolute -top-4 left-6 h-10 w-10 rounded-full border border-[#64a2ff]/40 animate-ping" />
              <div className="absolute -bottom-3 right-8 h-8 w-8 rounded-full border border-[#064585]/40 animate-ping" />

              {/*  floating card */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative bg-white/80 backdrop-blur-xl border border-[#5989C8]/20 shadow-lg rounded-3xl px-6 py-5 md:px-7 md:py-6 animate-float">
                  <div className="inline-flex items-center gap-2 rounded-full bg-[#eef3ff] px-3 py-1 mb-4">
                    <span className="h-2 w-2 rounded-full bg-[#28c76f]" />
                    <span className="text-[10px] md:text-xs font-semibold tracking-wide text-[#064585] uppercase">
                      Real-World Skills
                    </span>
                  </div>

                  <h3 className="text-lg md:text-xl font-semibold text-slate-900">
                    Learn. Build. Grow.
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-slate-600 leading-relaxed">
                    Master web development concepts step-by-step with{" "}
                    <span className="font-semibold text-[#064585]">
                      guided projects
                    </span>{" "}
                    and{" "}
                    <span className="font-semibold text-[#064585]">
                      hands-on practice
                    </span>
                    .
                  </p>

                  <div className="mt-4 flex flex-wrap gap-2">
                    <span className="text-[10px] md:text-xs px-3 py-1 rounded-full bg-[#eef3ff] text-[#064585] font-medium">
                      HTML &amp; CSS
                    </span>
                    <span className="text-[10px] md:text-xs px-3 py-1 rounded-full bg-[#e5f3ff] text-[#064585] font-medium">
                      JavaScript
                    </span>
                    <span className="text-[10px] md:text-xs px-3 py-1 rounded-full bg-[#e8ecff] text-[#064585] font-medium">
                      React &amp; Node
                    </span>
                  </div>

                  <div className="mt-5 flex items-center justify-between text-[10px] md:text-xs text-slate-500">
                    <div>
                      <p className="font-semibold text-slate-800">100+ hrs</p>
                      <p>of guided learning</p>
                    </div>
                    <div>
                      <p className="font-semibold text-slate-800">
                        Project-first
                      </p>
                      <p>learning approach</p>
                    </div>
                  </div>

                  <div className="absolute -right-4 -top-4 bg-gradient-to-br from-[#64a2ff] to-[#064585] text-white text-[10px] md:text-xs font-semibold px-3 py-2 rounded-2xl shadow-lg animate-bounce">
                    Beginner Friendly
                  </div>
                </div>
              </div>
              <div className="absolute inset-4 rounded-3xl border border-dashed border-[#5989C8]/30" />
            </div>
          </div>

          {/* Right: Content */}
          <div
            className="w-full md:w-1/2 flex flex-col justify-center"
            data-aos="fade-left"
          >
            <p className="text-[10px] text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-[#064585]">
              About Us
            </p>

            <h1 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight text-slate-900">
              Building{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#64a2ff] via-[#5989C8] to-[#064585]">
                Strong Foundations
              </span>{" "}
              for Lifelong Success
            </h1>

            <p className="mt-4 text-sm sm:text-base md:text-lg text-slate-600 leading-relaxed">
              At <span className="font-semibold">Web_Bocket Classes</span>, we
              are passionate about empowering individuals through education.
              Established with the goal of providing high-quality, accessible
              learning opportunities, we offer a wide range of courses designed
              to equip students with the skills and knowledge they need to
              thrive in today&apos;s competitive world.
            </p>

            <ul className="mt-4 space-y-2 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-[6px] w-2 h-2 rounded-full bg-[#5989C8]" />
                <span>We take care of our students</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="mt-[6px] w-2 h-2 rounded-full bg-[#064585]" />
                <span>Clean atmosphere &amp; discipline is our motto</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StrongFoundations;
